<template>
  <div class="offset-sm-1 col-sm-9 col-10 offset-1 system-settings">
    <div class="system-settings-content">
      <JobPostingAutoDisplay />
      <DomainIpSettings />
    </div>
  </div>
</template>

<script>
import JobPostingAutoDisplay from '@/components/auth/JobPostingAutoDisplay.vue';
import DomainIpSettings from '@/components/settings/DomainIpSettings.vue';

export default {
  name: 'SystemSettings',
  components: { JobPostingAutoDisplay, DomainIpSettings },
};
</script>

<style scoped>
.system-settings {
  margin: 55px auto;
}

.system-settings-content {
  display: flex;
  flex-direction: column;
}
</style>
